import _get from 'lodash/get';
import {
    Communication,
    FreewheelPlugin,
    DfpPlugin,
    OmniturePlugin,
    ChartBeatPlugin,
    ConvivaPlugin
} from 'mlb-player-plugins';
import {
    MediaPlayerEvents
} from 'mlb-media-player';
import pageMeta from 'pageMeta/pageMeta';
import DfpConfigUtil from '../advertising/dfp-config-util';
import wiretapVideoJson from './analytics/omniture/tracking-video.json';
/**
 *
 * @module PluginConfigHelper
 * @desc
 * @class PluginConfigHelper
 *
 */
class PluginConfigHelper {

    static getBandwagonConfig(mediaConfig) {

        const {
            MEDIA_START,
            MEDIA_PAUSE,
            MEDIA_COMPLETE,
        } = MediaPlayerEvents.HTML5;
        //TODO: override and/or merge with an existing config

        const bandwagonAdapterPluginConfig = {
            name: 'BandwagonAdapter',
            type: 'COMMUNICATION',
            pluginReference: Communication.BandwagonAdapter,
            bandwagonKey: _get(window.requestParams, 'query.playerId'),
            targetPlayerEvents: {
                [MEDIA_START]: 'mediaStart',
                [MEDIA_PAUSE]: 'mediaPaused',
                [MEDIA_COMPLETE]: 'mediaComplete',
            },
            targetPluginEvents: {
                adStart: 'adStart',
                adComplete: 'adComplete',
            },
        };

        return bandwagonAdapterPluginConfig;

    }

    static getEventReplicatorConfig(mediaConfig) {

        //TODO: override and/or merge with an existing config

        const eventReplicatorPluginConfig = {
            name: 'EventReplicator',
            type: 'COMMUNICATION',
            pluginReference: Communication.EventReplicator,
            parentWindow: window.parent,
            playerId: _get(window.requestParams, 'query.playerId'),
            bandwagonKey: _get(window.requestParams, 'query.playerId'),
            eventsToReplicate: {
                META_DATA_LOADED: 'META_DATA_LOADED',
                FLASH_BLOCK: 'flashBlock',
                MEDIA_START: 'mediaStart',
                MEDIA_PAUSE: 'mediaPaused',
                MEDIA_COMPLETE: 'mediaComplete',
                MEDIA_RESUME: 'mediaResume',
                AD_START: 'adStart',
                AD_COMPLETE: 'adComplete',
                __media_app_flashblock_detected: '__media_app_flashblock_detected',
                __media_app_flash_required: '__media_app_flash_required',
            },
        };

        return eventReplicatorPluginConfig;

    }

    static getAdvertisingPluginConfig(mediaConfig) {

        const isFreewheelSite = _get(mediaConfig, 'videocore.advertising.freewheel.isFreeWheelSite');
        const isDfpSite = _get(mediaConfig, 'videocore.advertising.dfp.isDFPSite');
        let adPluginConfig;

        if(isFreewheelSite) {

            adPluginConfig = {
                name: 'FreewheelPlugin',
                type: 'ADVERTISING',
                pluginReference: FreewheelPlugin,
                videoAdContainerId: 'ad-container',
                controls: true,
                autoPlay: true,
                muted: true,
                playsinline: true,
                freewheel: _get(mediaConfig, 'videocore.advertising.freewheel'),
            };


        } else if(isDfpSite) {

            adPluginConfig = {
                name: 'DfpPlugin',
                type: 'ADVERTISING',
                pluginReference: DfpPlugin,
                videoAdContainerId: 'ad-container',
                controls: true,
                autoPlay: true,
                muted: true,
                playsinline: true,
                dfp: _get(mediaConfig, 'videocore.advertising.dfp'),
            };

            /**
             * Add the getDfpParams helper that will be called with every ad request.
             * This is where we'll override, update, and reset values
             */
            adPluginConfig.dfp.getDfpParams = DfpConfigUtil.getDfpParams;

        } else {

            console.error('No advertising plugin configuration found!');

        }

        return adPluginConfig;

    }

    static getOmniturePluginConfig(mediaConfig) {

        const omnitureConfig =  {
            name: 'OmniturePlugin',
            type: 'ANALYTICS',
            pluginReference: OmniturePlugin,
            omniture: {
                siteTraffic: 'mlb',
                section: 'vpp',
                wiretapVideoJson: wiretapVideoJson,
                bandwagonPlayerEvents: {
                    MEDIA_LOAD_START: 'loadstart',
                    MEDIA_START: 'play',
                    MEDIA_COMPLETE: 'ended',
                },
            },
        };

        return omnitureConfig;

    }

    static getChartBeatPluginConfig(mediaConfig) {

        const chartBeatConfig = {
            name: "ChartBeatPlugin",
            type: "ANALYTICS",
            pluginReference: ChartBeatPlugin,
        };

        return chartBeatConfig;

    }

    static getConvivaPluginConfig(mediaConfig) {

        const convivaConfig = {
            name: 'ConvivaPlugin',
            type: 'ANALYTICS',
            pluginReference: ConvivaPlugin,
            conviva: {
                applicationName: 'MLB Embed Player',
                sdk: {
                    core: {
                        qa: 'https://qa.mlbstatic.com/video/libs/conviva/1.0.0/conviva-core-sdk.min.js',
                        beta: 'https://beta.mlbstatic.com/video/libs/conviva/1.0.0/conviva-core-sdk.min.js',
                        prod: 'https://www.mlbstatic.com/video/libs/conviva/1.0.0/conviva-core-sdk.min.js',
                    },
                    html5Impl: {
                        qa: 'https://qa.mlbstatic.com/video/libs/conviva/1.0.0/conviva-html5native-impl.js',
                        beta: 'https://beta.mlbstatic.com/video/libs/conviva/1.0.0/conviva-html5native-impl.js',
                        prod: 'https://www.mlbstatic.com/video/libs/conviva/1.0.0/conviva-html5native-impl.js',
                    },
                },
                custom: {
                    nonGameLiveEvent: 'true',
                    prt: 'mlb',
                },
                customerKey: '4b54c372f1160c0214905f3dcd3e126ebb6b41f4',
            },
        };

        return convivaConfig;

    }

}

export default PluginConfigHelper;
